import axios from "axios";
import store from "../store";
import { email } from "vuelidate/lib/validators";

const state = {
  // agencyFromEmail: 'tinytreasuresnyc@enginehire.io',
  agencyFromEmail: "ruka@tinytreasuresnyc.com",
  agencyReplyEmail: "info@tinytreasuresnyc.com",
  enginehireAdminEmail: "aakash@enginehire.ca",
  enginehireLoggingEmail: "enginehirelogs@gmail.com",

  agencyAdminEmail: 'ruka@tinytreasuresnyc.com',
  agencyAdminEmail2: 'recruit@tinytreasuresnyc.com',
  agencyAdminEmail3: 'info@tinytreasuresnyc.com',
  agencyAdminEmails: ['ruka@tinytreasuresnyc.com', 'recruit@tinytreasuresnyc.com', 'info@tinytreasuresnyc.com'],

  // agencyAdminEmail: "aakash@enginehire.io",
  // agencyAdminEmail2: "aakash@enginehire.io",
  // agencyAdminEmail3: "aakash@enginehire.io",
  // agencyAdminEmails: ['aakash@enginehire.io', 'aakash@enginehire.io', 'aakash@enginehire.io'],
};

const mutations = {};

const actions = {
  sendEmail({ commit, dispatch }, emailInfo) {
    console.log(emailInfo.email);
    console.log(emailInfo.userID);
    axios
      .post("/optimum/email/", {
        subject: emailInfo.subject,
        message: emailInfo.message,
        from_address: emailInfo.from,
        to_address: emailInfo.email,
        reply_address: emailInfo.reply,
        user_id: emailInfo.userID
      })
      .then(res => {
        console.log("Email Sent");
        console.log(res);

        dispatch("logEmail", {
          subject: emailInfo.subject,
          message: emailInfo.message,
          from_address: emailInfo.from,
          to_address: res.data.email,
          reply_address: emailInfo.reply,
          user_id: emailInfo.userID
        }); // Lecture 360
      })
      .catch(error => console.log(error));
  },

  sendEmails({ commit, dispatch }, emailInfo) {
    //
    // Send the same email to a list of several emails
    //
    console.log(emailInfo.emails);
    console.log(emailInfo.userID);
    for (var emailIndex in emailInfo.emails) {
      console.log(emailInfo.message);
      // console.log(emailIndex)
      // console.log(emailInfo.emails[emailIndex])

      let message = emailInfo.message;
      // If we are sending an html email we want to add the tags and the footer
      if (emailInfo.html) {
        message =
          "<html><head></head><body>" +
          emailInfo.message +
          '<img src="https://s3.us-east-2.amazonaws.com/ttna.enginehire.io/ttna-logo-email-footer.jpg"></body></html>';
          // "</body></html>";
      }

      axios
        .post("/optimum/email/", {
          subject: emailInfo.subject,
          // message: emailInfo.message,
          // message: '<html><head></head><body><p>'+emailInfo.message+'</p><img src="https://s3.us-east-2.amazonaws.com/pinknannies.enginehire.io/PN+E-mail+signature-01.png"></body></html>',
          message: message,
          from_address: emailInfo.from,
          to_address: emailInfo.emails[emailIndex],
          reply_address: emailInfo.reply,
          user_id: emailInfo.userID
        })
        .then(res => {
          console.log("Email Sent to " + res.data.email);
          // console.log('Email Sent to ' + emailInfo.emails[emailIndex])
          // console.log(emailInfo.emails)
          // console.log(emailIndex)
          // console.log(emailInfo.emails[emailIndex])
          // console.log(res)
          dispatch("logEmail", {
            subject: emailInfo.subject,
            message: emailInfo.message,
            from_address: emailInfo.from,
            to_address: res.data.email,
            reply_address: emailInfo.reply,
            user_id: emailInfo.userID
          }); // Lecture 360
        })
        .catch(error => console.log(error));
    }
  },

  logEmail({ commit, dispatch }, emailInfo) {
    console.log("Logging Email");
    console.log(emailInfo);
    console.log(emailInfo.to_address);
    console.log(store.getters.userID);
    if (emailInfo.to_address != state.enginehireAdminEmail && emailInfo.to_address != state.enginehireLoggingEmail) {
      // Don't want to log emails sent to enginehire admin
      axios
        .post("/api/emaillogs/", {
          recipient: emailInfo.user_id,
          sender: store.getters.userID,
          subject: emailInfo.subject,
          body: emailInfo.message,
          to_email: emailInfo.to_address,
          from_email: emailInfo.from_address,
          reply_email: emailInfo.reply_address,
          agency_owner: store.getters.agencyName,
          agency: store.getters.agencyID
        })
        .then(res => {
          console.log(res);
          console.log("Email logged!");
        })
        .catch(error => console.log(error));
    }
  },

  htmlify(message) {
    return "<html><head></head><body><h1>" + message + "</h1></body></html>";
  }

  // sendSMS({commit, dispatch}, SMSInfo) {
  //   console.log(SMSInfo)
  //   axios.post('/optimum/email/',
  //       {
  //         subject: emailInfo.subject,
  //         message: emailInfo.message,
  //         from_address: emailInfo.from,
  //         to_address: emailInfo.email,
  //         reply_address: emailInfo.reply,
  //         user_id: emailInfo.userID,
  //       }
  //     )
  //       .then(res => {
  //         console.log('Email Sent')
  //         console.log(res)

  //         dispatch('logSMS',
  //           {
  //             subject: emailInfo.subject,
  //             message: emailInfo.message,
  //             from_address: emailInfo.from,
  //             to_address: res.data.email,
  //             reply_address: emailInfo.reply,
  //             user_id: emailInfo.userID,
  //           }
  //         ) // Lecture 360
  //       })
  //       .catch(error => console.log(error))
  // },

  // commsAlive() {
  //   console.log('Comms Alive!!')
  // },
  // sendMasivSMS({commit}, SMSInfo) {
  //   console.log('Sending Masiv SMS')
  //   console.log(SMSInfo)

  //   // axios.post('https://api.masiv.co/SmsHandlers/sendhandler.ashx?action=sendmessage&username=Api_5_A73&password=6DZW7HHFQ0&recipient='+SMSInfo.phone+'&originator=3508830809&messagedata='+SMSInfo.message+'&longMessage=true&flash=false&premium=false')
  //   axios.post('https://cors-anywhere.herokuapp.com/https://api.masiv.co/SmsHandlers/sendhandler.ashx?action=sendmessage&username=Api_5_A73&password=6DZW7HHFQ0&recipient='+SMSInfo.phone+'&originator=3508830809&messagedata='+SMSInfo.message+'&longMessage=true&flash=false&premium=false')
  //     .then(res => {
  //       console.log(res)
  //     })
  //     .catch(error => console.log(error))
  // },
};

const getters = {
  agencyFromEmail(state) {
    return state.agencyFromEmail;
  },
  agencyReplyEmail(state) {
    return state.agencyReplyEmail;
  },
  enginehireAdminEmail(state) {
    return state.enginehireAdminEmail;
  },
  agencyAdminEmail(state) {
    return state.agencyAdminEmail;
  },
  agencyAdminEmail2(state) {
    return state.agencyAdminEmail2;
  },
  agencyAdminEmail3(state) {
    return state.agencyAdminEmail3;
  },
  agencyAdminEmails(state) {
    return state.agencyAdminEmails;
  },
  enginehireLoggingEmail(state) {
    return state.enginehireLoggingEmail;
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/communication.js